import DerivativeHome from "./DerivativeHome/DerivativeHome"
import DerivativesTalk from "./DerivativeTalk/DerivativesTalk"
export default function Derivatives() {
    return (
        <main>
        <DerivativeHome/>
        <DerivativesTalk/>
        </main>
    )
}